// extracted by mini-css-extract-plugin
export default {"root":"SavedSearch_root__yflwE","title":"SavedSearch_title__LcwVK","info":"SavedSearch_info__2TF8k","sample":"SavedSearch_sample__0DvKL"};